// assets
import visa from './visa.png'
import mastercard from './mastercard.png'
import amex from './amex.png'
import stripe from './stripe.png'
import gpay from './gpay.png'
import applepay from './applepay.png'
// types
import type { FooterPaymentMethod } from '../types/interfaces'

export const PAYMENT_BADGES: Record<FooterPaymentMethod, string> = {
  visa,
  mastercard,
  amex,
  stripe,
  gpay,
  applepay,
}
